module.exports = __webpack_public_path__ + "static/media/7_seven_Severe.96d6307f.svg";